<div class="modal-content border-0">
  <div class="modal-header align-items-start p-4 border-bottom-0">
    @if (modalData.color == 'primary') {
    <i class="bi {{modalData.icon}} fs-1 text-primary" style="height: 40px;"></i>
    }@else {
    <div class="d-inline-flex align-items-center justify-content-center rounded p-3 bg-{{modalData.color}}"
      style="width: 40px; height: 40px;">
      <i class="bi {{modalData.icon}} fs-3 text-white"></i>
    </div>
    }
    <button type="button" class="btn-close" aria-label="Close" tabindex="-1" (click)="activeModal.close()"></button>
  </div>
  <div class="modal-body p-4 py-0">
    <h6 class="mb-0 mb-2 rounded">{{ modalData.title }}</h6>
    <p class="mb-0 mb-3 small rounded text-muted">{{ modalData.content }}</p>
    @if (modalData.list) {
    <ol class="text-muted">
      @for (item of modalData.list; track $index) {
      <li>{{item}}</li>
      }
    </ol>
    }
  </div>
  <div class="modal-footer d-flex justify-content-center p-3 py-2">
    @if (modalData.cancelButtonText) {
    <button type="button" class="btn btn-outline-primary px-6" (click)="activeModal.close(false)" tabindex="-1">{{
      modalData.cancelButtonText }}</button>
    }
    <button type="button" class="btn text-white btn-{{modalData.color}} px-6 ms-3" (click)="activeModal.close(true)">{{
      modalData.confirmButtonText }}</button>
  </div>
</div>